import { Category, Subcategory } from '@omniafishing/core';
import _ from 'lodash';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { getCategoryBySubcategoryUrl, getSubcategoryByUrlPath } from '../categories_subcategories';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';
import { SubcategoryProductsGridContainer } from '../components/subcategory_products_grid/subcategory_products_grid_container';

interface SubcategoryPageProps {
  subcategoryUrlPath: string;
  categories: Category[];
  subcategories: Subcategory[];
}

type Props = SubcategoryPageProps &
  RouteComponentProps<{
    subcategory: string;
  }>;

export default class SubcategoryPage extends React.Component<Props, {}> {
  render() {
    const { subcategoryUrlPath, categories, subcategories } = this.props;
    const subcategory = getSubcategoryByUrlPath(subcategories, subcategoryUrlPath);
    const category = getCategoryBySubcategoryUrl(categories, subcategoryUrlPath);
    const metaTitle =
      (subcategory && subcategory.meta_title) ||
      (subcategory && _.startCase(subcategory.display_name));
    return (
      <ScrollToTop>
        <section>
          <SEO titleTemplate="%s" title={metaTitle} description={subcategory.meta_description} />
          <SubcategoryProductsGridContainer
            subcategory={subcategory}
            category={category}
            key={subcategoryUrlPath}
          />
        </section>
      </ScrollToTop>
    );
  }
}
